// extracted by mini-css-extract-plugin
export default {"ScrollNav":"udbnb7qiGSVLf5UI0jM8","ScrollNav__location":"MebqbigJRpbcLdb_8Uz8"};